type LibraryView = 'collections' | 'assets' | 'products';

const LIBRARY_BREADCRUMB = {
  label: 'Library',
  href: '/library',
};

const HOME_BREADCRUMB = {
  label: 'Home',
  href: '/',
};

const EXPLORE_BREADCRUMB = {
  label: 'Explore',
  href: '/explore',
};

/**
 * Get a library breadcrumb with the appropriate label based on the view
 * @param view - The library tab view (collections, assets, or products)
 * @returns A breadcrumb object with the appropriate label
 */
const getLibraryBreadcrumb = (view?: LibraryView) => {
  const labels: Record<LibraryView, string> = {
    collections: 'Collections',
    assets: 'Assets',
    products: 'Product Pages',
  };

  return {
    label: view ? labels[view] : 'Library',
    href: '/library',
  };
};

export { LIBRARY_BREADCRUMB, HOME_BREADCRUMB, EXPLORE_BREADCRUMB, getLibraryBreadcrumb };
export type { LibraryView };
